// extracted by mini-css-extract-plugin
export var button = "styles-module--button--90196";
export var outlined = "styles-module--outlined--fb67b";
export var primary = "styles-module--primary--62f96";
export var text = "styles-module--text--5b3dc";
export var withIcon = "styles-module--withIcon--2b12b";